import { useAuth } from '../stores/auth';

export function Header() {
  const auth = useAuth();
  const role = auth.user?.role;
  const isCustomer = role === 'CUSTOMER';

  return (
    <div className="app-header">
      <div className="app-title">
        <span>{isCustomer ? '🚗' : '🔧'}</span>
        <span>AutoService</span>
        {isCustomer && <span className="tag" style={{ marginLeft: 4 }}>Mijoz</span>}
        {auth.activeWorkshop && (
          <span className="tag primary" style={{ marginLeft: 4 }}>{auth.activeWorkshop.name}</span>
        )}
      </div>
    </div>
  );
}
